import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import { BrowserRouter as Router } from 'react-router-dom';
import ErrorBoundary from './hoc/ErrorBoundary';
import CoffeeShopService from './services/coffeeShopService';
import CoffeeServiceContext from './contexts/coffeeServiceContext';

const coffeeService = new CoffeeShopService()

ReactDOM.render(
  <ErrorBoundary>
    <CoffeeServiceContext.Provider value={coffeeService}>
      <Router>
        <App />
      </Router>
    </CoffeeServiceContext.Provider>
  </ErrorBoundary>, document.getElementById('root'));

